
export const truncateTitle = (title: string, maxLength: number = 30) => {
  return title.length > maxLength ? `${title.substring(0, maxLength)}...` : title;
};

export const getRelativeTime = (date: string) => {
  const now = new Date();
  const past = new Date(date);
  const diffTime = Math.abs(now.getTime() - past.getTime());
  const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
  
  if (diffHours <= 24) {
    return 'Recent';
  } else if (diffHours <= 168) { // 7 days * 24 hours
    return '7 Days';
  } else {
    return '30 Days';
  }
};

// New utility functions for the latest Lovable version
export const formatDate = (date: string): string => {
  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  };
  return new Date(date).toLocaleDateString(undefined, options);
};

export const sortChatsByDate = (chats: any[]): any[] => {
  return [...chats].sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
};
